<template>
  <div>
    <el-radio-group v-model="radio" @change="optRole()">
      <el-radio-button label="1">司機</el-radio-button>
      <el-radio-button label="2">企業</el-radio-button>
    </el-radio-group>
  </div>
</template>

<script>
export default {
  data() {
    return {
      radio: 2,
    }
  },
  methods: {
    optRole() {
      this.$emit('optRole', this.radio)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/element_ui/RolesRadioButton.vue